import { ReactComponent as DeviceSvg } from "./device.svg";
const DeviceIcon = (props) => {
  return <DeviceSvg {...props} />;
};

export default DeviceIcon;
